import React, { useState } from 'react'
import { Col, Row } from 'reactstrap'
import { PageTitle, ReactCSSTransitionGroup } from '../../../Components'
import AcessosPorDia from './AcessosPorDia'
import AcessosPorHora from './AcessosPorHora'
import TempoMedioTotal from './TempoMedioTotal'
import AcessosPorVersaoApp from './AcessosPorVersaoApp'
import AcessosPorPlataforma from './AcessosPorPlataforma'
import AcessosPorPraca from './AcessosPorPraca'
import EvolucaoPosts from './EvolucaoPosts'
import CardFilter from './CardFilter'
import AcessosPorPeriodoDoDia from './AcessosPorPeriodoDoDia'
import Indicadores from './Indicadores'

export default function Dashboards() {
  const [filters, setFilters] = useState()

  return (
    <>
      <ReactCSSTransitionGroup component="div" transitionName="TabsAnimation" transitionAppear={true} transitionAppearTimeout={0} transitionEnter={false} transitionLeave={false}>
        <div className="body-tabs body-tabs-layout">
          <PageTitle heading="Dashboard" subheading="Audiência das transmissões e engajamento dos posts · horário de Brasília"></PageTitle>
          <div className="page-content">
            <CardFilter change={(ev) => setFilters(ev)} />

            <Indicadores filters={filters} />

            <Row>
              <Col xl={8}>
                <AcessosPorDia filters={filters} />
              </Col>
              <Col xl={4}>
                <AcessosPorHora filters={filters} />
              </Col>

              <Col xl={6}>
                <TempoMedioTotal filters={filters} />
              </Col>
              <Col xl={6}>
                <AcessosPorPeriodoDoDia filters={filters} />
              </Col>

              <Col xl={6}>
                <AcessosPorPraca filters={filters} />
              </Col>
              <Col xl={6}>
                <EvolucaoPosts filters={filters} />
              </Col>

              <Col xl={6}>
                <AcessosPorPlataforma filters={filters} />
              </Col>
              <Col xl={6}>
                <AcessosPorVersaoApp filters={filters} />
              </Col>
            </Row>
          </div>
        </div>
      </ReactCSSTransitionGroup>
    </>
  )
}
